export default {
  LessonNote: {
    PlaceholderEnter: 'Nhấn Enter để hoàn thành',
    AddNoteSuccess: 'Thêm ghi chú thành công',
    UpdateNoteSuccess: 'Cập nhật ghi chú thành công',
    DeleteNoteSuccess: 'Xóa ghi chú thành công',
    NoteError: 'Có lỗi xảy ra'
  }
}
